import { ServicePricing } from '@/components/services/ServicePricing'
import { serviceOffers } from '@/data/pricing'

export const ProgrammePricing = () => (
  <ServicePricing
    title="Three months of"
    accent="personalised support"
    description="A considered approach to your wellbeing, with time to build, review and sustain meaningful changes."
    offers={[serviceOffers.threeMonthPackage]}
  />
)
